import { render, staticRenderFns } from "./BillboardPreview.vue?vue&type=template&id=775d4e2b&scoped=true&"
import script from "./BillboardPreview.vue?vue&type=script&lang=ts&"
export * from "./BillboardPreview.vue?vue&type=script&lang=ts&"
import style0 from "./BillboardPreview.vue?vue&type=style&index=0&id=775d4e2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775d4e2b",
  null
  
)

export default component.exports